"use client";
import { useState, useEffect } from "react";
import { endpoint } from "../../utils/endpoints";
import { handleApiCall } from "../../apis";
import { useLocation, useNavigate } from "react-router-dom";
import SignupSlider from "../../Components/Signupslider/index";
import { PopUp } from "../../utils/tost";
import { toast } from "react-toastify";
const OTPVerification = () => {
  const [otp, setOtp] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  console.log(state, "state");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // When coming from login (code 405), trigger OTP generation API
  useEffect(() => {
    const triggerLoginOtp = async () => {
      if (!state?.email || !state?.password) return;

      try {
        const body = {
          step: "3",
          email: state.email,
          password: state.password,
          confirmPassword: state.confirmPassword || state.password,
        };
        await handleApiCall("post", `${endpoint.registerVendor}`, body);
      } catch (err) {
        console.error("Error triggering login OTP:", err);
      }
    };

    if (state?.type === "login") {
      triggerLoginOtp();
    }
  }, [state]);
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (otp.length < 4) {
      setError("Please enter valid OTP.");
      return;
    }

    try {
      setLoading(true);
      const response = await handleApiCall(
        "post",
        `${endpoint.verifyOtpSignup}`,
        {
          email: state.email,
          otp: otp,
          type: state.type,
        }
      );

      if (response?.data?.code === 200) {
        if (state?.type === "vendorSignUp") {
          navigate("/login", { state: { registrationComplete: true } });
        } else if (state?.type === "forgotPassword") {
          toast.success("OTP verified successfully.");
          navigate("/ResetPassword", {
            replace: true,
            state: { email: state.email, otpVerified: true },
          });
        } else {
          toast.success("OTP verified successfully.");
          navigate("/login");
        }
      } else if (response?.response?.data) {
        if (response?.response?.data?.code === 401) {
          toast.error(response?.response?.data?.errorMessage);
        } else {
          toast.error(response?.response?.data?.errorMessage);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleResend = async (e) => {
    e.preventDefault();

    console.log("================", location);

    try {
      setLoading(true);
      const resendPayload = {
        email: state.email,
        ...(state?.type === "vendorSignUp" || state?.type === "signup"
          ? { type: "signup" }
          : {}),
      };
      const response = await handleApiCall(
        "post",
        `${endpoint.forgotPassword}`,
        resendPayload
      );
      if (response?.data?.code === 200) {
        PopUp("OTP Send Successfully.", "", "success");
        // const sessionToken = response?.data?.data?.token;
        // // dispatch(setUserData(response?.data));
        // console.log(response?.data?.data?.user_permission, "user_permission")

        // localStorage.setItem('sessionToken', sessionToken);
        // localStorage.setItem('lastActivityTime', Date.now());
        // setTimeout(() => {
        //   navigate("/");
        // }, 500);
      } else if (response?.response?.data) {
        if (response?.response?.data?.code === 401) {
          toast.error(response?.response?.data?.errorMessage);
        } else {
          toast.error(response?.response?.data?.errorMessage);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <div className="w-full md:flex block">
        <div className="md:w-6/12 w-full">
          <div className="flex justify-center h-screen">
            <div className="block md:w-80 w-10/12 space-y-12 mt-[30px]">
              <img src="/images/black-logo.svg" alt="" className="mx-auto" />
              <div>
                <h1 className="text-2xl text-black text-center py-4 font-BonaNovaRegular">
                  OTP Verification
                </h1>
                <form
                  action="#"
                  method="POST"
                  className=""
                  onSubmit={handleSubmit}
                >
                  <div className="mb-4">
                    <div className="text-[13px] font-Montserratmedium text-[#2B2B2B] opacity-50 mb-[5px]">
                      Enter OTP received on mail{" "}
                    </div>
                    <input
                      type="text"
                      id="number"
                      name="Otp"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      maxLength={4}
                      placeholder="Enter OTP received on mail"
                      required
                      value={otp}
                      onChange={(e) => {
                        const value = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 4); // Allow only numbers and max 4 digits
                        setOtp(value);
                      }}
                      onKeyDown={(e) => {
                        if (
                          !/^[0-9]$/.test(e.key) &&
                          e.key !== "Backspace" &&
                          e.key !== "Delete" &&
                          e.key !== "ArrowLeft" &&
                          e.key !== "ArrowRight"
                        ) {
                          e.preventDefault();
                        }
                      }}
                      className="mt-1 w-full px-3 py-2.5 border border-inputfieldborder pr-10 bg-white outline-none text-13 font-Montserratmedium text-forgetpassword"
                    />
                    {error && (
                      <p className="text-red-500 text-xs mt-1">{error}</p>
                    )}
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="my-2 px-8 py-2 bg-buttonbg text-13 text-white focus:outline-none font-Montserratmedium w-full"
                  >
                    Verify OTP
                  </button>
                </form>
                <p className="text-newuser text-13 font-Montserratmedium py-2 text-center mt-2">
                  Didn't receive OTP?{" "}
                  <span
                    onClick={(e) => (loading ? null : handleResend(e))}
                    className="text-subhead cursor-pointer"
                  >
                    {" "}
                    Resend{" "}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="md:w-6/12 w-full hidden h-screen md:block">
          <SignupSlider />
        </div>
      </div>
</>
  );
};

export default OTPVerification;
